var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"discover"},[_c('span',{staticClass:"discover__circle"}),_c('span',{staticClass:"discover__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }